import { ChatUser, INTERFACE_PERMISSIONS } from '@vyce/core/src/types';
import { usePermissions } from '@vyce/core/src/hooks/usePermissions';
import { useMemo } from 'react';

import { useActions, useTypedSelector, useInviteButton } from 'src/hooks';
import { WidgetModule } from 'src/modules';

export const useTimeDashboardData = () => {
  const { dashboards, first_name, last_name, email, phone, photo, uuid } = useTypedSelector(
    state => state.user
  );
  const { selectedCompanyAppData, selectedCompany } = useTypedSelector(state => state.helper);
  const {
    isInviteFormOpen,
    subscribeLoading,
    isActivateSubscriptionDialogOpen,
    simpleSubscribe,
    setCloseInviteForm,
    handleInviteButtonClick,
    closeActivateSubscriptionDialog,
  } = useInviteButton();
  const { can } = usePermissions();
  const { updateUserDashboards } = useActions();

  const hasTimePermissions = can(INTERFACE_PERMISSIONS.TIME);
  const hasTeamPermissions = can(INTERFACE_PERMISSIONS.TEAMS);
  const chatUser: ChatUser = useMemo(() => {
    return {
      uid: uuid,
      name: `${first_name} ${last_name}`,
      email,
      phone,
      photo,
    };
  }, [first_name, last_name, email, phone, photo, uuid]);

  const contextOptions = useMemo(
    () => ({
      dashboards,
      name: first_name,
      selectedCompanyId: selectedCompany?.uuid ?? '',
      timePermission: !!hasTimePermissions,
      teamPermission: !!hasTeamPermissions,
      updateUserDashboards,
      widgetComponent: WidgetModule,
      onOpenUniversalInviteForm: handleInviteButtonClick,
      chatUser,
    }),
    [dashboards, first_name, selectedCompanyAppData, selectedCompany?.uuid, updateUserDashboards]
  );
  return {
    isActivateSubscriptionDialogOpen,
    subscribeLoading,
    contextOptions,
    isInviteFormOpen,
    selectedCompany,
    simpleSubscribe,
    setCloseInviteForm,
    closeActivateSubscriptionDialog,
    chatUser,
  };
};
